import React from 'react'
import Menu from "./Menu"
import {observer} from "mobx-react-lite"

const Header = () => <Menu/>
export default Header